module.exports = __webpack_public_path__ + "img/睦邻分中心2.49a4ae22.jpg";